<app-breadcrumb *ngIf="datadone" [title]="pageDetails['title']" [breadcrumb]="pageDetails['title']"></app-breadcrumb>
<!-- about section start -->
<section class="about-page section-b-space">
    <div class="container">
        <div class="row" *ngIf="datadone">
            <div class="col-lg-12" *ngIf="pageDetails['image']">
                <div class="banner-section">
                    <img  [src]="urlimage+pageDetails['image']" class="img-fluid" alt="about-us"  />
                </div>
            </div>
            <div class="col-sm-12">
                <!-- <h4 [innerHTML]="pageDetails['title']"></h4> -->
                <p [innerHTML]="pageDetails['description']"></p>
                
            </div>
        </div>
    </div>
</section>
<!-- about section end -->

